export const ClientData = [
  {
    id:1,
    clientName: "dfgdfg",
    unitName: "cvbcv",
   unitLocation: "sdfggsdfdgf",
    contactPersons: [
        {
            department: "UI/UX",
            designation: "Developer",
            mobileNumber: "1234567489",
            mailId: "df@gmail.com"
        }
    ]
}
];
